import {useEffect,useState} from "react";
import {useImages} from "./useImages";
import "../styleSheets/creditStyle.css";
import {useTopCredits} from "./homeCredit";

function useScreenSize() {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return width;
}
//TODO: Add filter, that has image movement transitions, add clips from each title upon hovering for 0.5s
export function Credits({type}) {
    const allImages = useImages('credits');
    const topImages = useTopCredits();

    const width = useScreenSize();

    let images;

    if (type === "home") {
        // Only apply limiting when using topImages
        let limit = 3;
        if (width < 900) limit = 2;
        if (width < 650) limit = 1;

        images = topImages.slice(0, limit);
    }
    else {
        // On non-home pages, show everything
        images = allImages;
    }
    return (
        <div className={`credit_wrapper ${type ==="home"? "home_credits": "full_credits"}`}>
            {images.map((img,index) =>(
                <div key={index} className= "credit_card" >
                    <div className= "credit_container">
                        <img src={img.imageURL||"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%2Fid%2FOIP.oilUvGQR2AvUk52fhPXgjwHaJ4%3Fpid%3DApi&f=1&ipt=962759404acae973df76bc1c167786dd3140d1f2eaa5dd841a7dcb1adb732039&ipo=images"} alt={img.caption || "Image"} className="credit_img" />
                    </div>
                    <p className="credit_caption">{img.caption}</p>

                </div>
            ))}
        </div>
    );
}